import React, {useEffect,useState} from 'react'
import {Link,useParams} from "react-router-dom";
import Header from '../../header/Header';
import Sidebarr from '../../sidebar/Sidebar';
import Tool from '../../sidebar/Tool';
import Footer from '../../footer/Footer';
import {CustomerAction,updateVendorStatus,vendorDelete} from "../../action";
import {useDispatch,useSelector} from "react-redux";
import axios from "../../helper/axios"

export default function ProductList() {
  const [purchaseData,setPurchaseData] = useState([]);
  const {email} = useParams()
  const dispatch = useDispatch();
  const vendorGetData=async()=>{
    const data = {email:email}
    const res = await axios.post("/getpurchase",data)
    setPurchaseData(res.data)

  }
  useEffect(()=>{
    vendorGetData();  
  },[])

  const blockStatus=(id)=>{
    const status="block";
    const data={id,status}
    dispatch(updateVendorStatus(data));
   vendorGetData(); 

    
  }
  const unBlockStatus=(id)=>{
    const status="active";
    const data={id,status}
    dispatch(updateVendorStatus(data));
    vendorGetData(); 
  }

  const deleteVendorBtn=(id)=>{ 
    const data={id}
    dispatch(vendorDelete(data));
  }
 
  const check=()=>{
    vendorGetData()
  }

	return (
		<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  <Sidebarr/>
         
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">
    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        Purchase Details 
      </h1>
      <ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>
    </section>
    {/* Main content */}
    <section className="content">
    <div className="row">
  <div className="col-md-3 col-sm-6 col-xs-12">
    <div className="info-box">
      <span className="info-box-icon bg-aqua">
        <i className="fa fa-shopping-cart" />
      </span>
      <div className="info-box-content">
        <span className="info-box-text">Total Orders</span>
        <span className="info-box-number">{purchaseData?.length}</span>
      </div>
    </div>
  </div>
  <div className="col-md-3 col-sm-6 col-xs-12">
    <div className="info-box">
      <span className="info-box-icon bg-green">
        <i className="fa fa-truck" />
      </span>
      <div className="info-box-content">
        <span className="info-box-text">Total Products</span>
        <span className="info-box-number">{purchaseData?.map(vd=>(
          <p>{vd?.productList?.length}</p>
          ))}</span>
      </div>
    </div>
  </div> 
</div>

      {/* Default box */}
      <div className="box">
         
        <div className="box-body">
        	<table className="table table-bordered table-striped dataTable" id="example1">
        	  <thead>
        	    <tr>
        	  	<th className="fw-bold">{" "}<input type="checkbox"/></th>
        	  	<th>Products Name</th>
              <th>Customer Name</th>
        	  	<th>Customer Email</th>
        	  	<th>Customer Phone</th> 
        	  	</tr>
        	  </thead>
        	  <tbody>
            {purchaseData?.map(vd=>(
        	  	<tr>
        	  		<td><input type="checkbox"/></td>
        	  		<td>
        	  			<span className="text-uppercase fs-1">{vd.productList.map(pl=>(
                      <p>{pl.name}</p>
                    ))}</span>
        	  		</td>
                <td>
                  <span className="text-uppercase fs-1">{vd.fname}</span>
                </td>
        	  		<td>
        	  			
                  <span className="text-uppercase fs-1">{vd.email}</span>
        	  		</td>
        	  		<td>
                  <span className="text-uppercase fs-1">{vd.phoneNumber}</span></td>
        	  		<td>
                  <span className="text-uppercase fs-1">{vd.status}</span></td>
        	  		<td>
        	  			{/*<button className="btn btn-default" onClick={(e)=>deleteVendorBtn(vd._id)}>
        	  				<i className="fa fa-trash"></i>
        	  			</button>*/}
        	  			{" "}
                  {" "} 

                  {" "}
                  {" "} 
        	  		</td>
        	  	</tr>
              ))
            }
        	  </tbody>
        	</table>
        </div> 
      </div> 
    </section> 
  </div> 
  <Footer/>
  <Tool/>  
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}